// @flow
import { path } from 'ramda'

import { getMoviesCountries } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_MOVIE_COUNTRIES_TYPE = 'movies_categories/FETCH_COUNTRIES'

const fetchMovieCountriesAction = (servicespec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_MOVIE_COUNTRIES_TYPE,
    payload: getMoviesCountries(publicApi, servicespec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchMovieCountries = (servicespec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchMovieCountriesAction(servicespec))

  const state = getState()
  const expires = path(['movieCountries', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchMovieCountriesAction(servicespec))
}
